import { useTranslation } from 'react-i18next';
import type { SubjectKind } from '@hp/domain';
import { Stat, StatStrip } from '../../components/ui/stat';
import type { QueueSummaryRow } from './queries';

/**
 * The whole queue at a glance for the selected entity type (or both): what is left to decide,
 * split by tier, how many records that covers, and what has already been decided.
 */
export function QueueStats({
  rows,
  entityType,
}: {
  rows: QueueSummaryRow[] | undefined;
  entityType: SubjectKind | '';
}) {
  const { t } = useTranslation('review');
  const sum = (pick: (r: QueueSummaryRow) => boolean, of: 'clusters' | 'records' = 'clusters'): number | undefined =>
    rows?.filter((r) => (!entityType || r.entityType === entityType) && pick(r)).reduce((n, r) => n + r[of], 0);
  return (
    <StatStrip>
      <Stat label={t('stats.pendingAuto')} value={sum((r) => r.status === 'pending' && r.tier === 'auto')} />
      <Stat label={t('stats.pendingReview')} value={sum((r) => r.status === 'pending' && r.tier === 'review')} />
      <Stat label={t('stats.pendingRecords')} value={sum((r) => r.status === 'pending', 'records')} />
      <Stat label={t('stats.approved')} value={sum((r) => r.status === 'approved')} />
      <Stat label={t('stats.declined')} value={sum((r) => r.status === 'declined')} />
      <Stat label={t('stats.merged')} value={sum((r) => r.status === 'merged')} />
      <Stat label={t('stats.deleted')} value={sum((r) => r.status === 'deleted')} />
    </StatStrip>
  );
}
